import { confirmAlert } from 'react-confirm-alert';

import { DeletePersonCardsConfirmation } from './DeletePersonCardsConfirmation';

interface ConfirmDeletePersonCardsProps {
  onConfirm: VoidFunction;
  onReject?: VoidFunction;
  externalIds: string[];
}
export function confirmDeletePersonCards({
  externalIds,
  onConfirm,
  onReject,
}: ConfirmDeletePersonCardsProps): void {
  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <DeletePersonCardsConfirmation
          externalIds={externalIds}
          onConfirm={() => {
            onConfirm();
            onClose();
          }}
          onReject={() => {
            onReject?.();
            onClose();
          }}
        />
      );
    },
  });
}
